
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconDefault as ObiBeaconDefaultElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-default.js';
 
 
 

 
 export const ObiBeaconDefault = createComponent({
   react: React,
   tagName: 'obi-beacon-default',
   elementClass: ObiBeaconDefaultElement,
   events: {
     
   }
  });
 
 